import { render, staticRenderFns } from "./DocumentacionGastos.vue?vue&type=template&id=2a537595&"
import script from "./DocumentacionGastos.vue?vue&type=script&lang=js&"
export * from "./DocumentacionGastos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports